import {
    getAxiosInstance,
} from '@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance.js'

let countPromise = null

export default {
    namespaced: true,
    state: {
        unseenCount: 0,
        loaded: false,
    },
    mutations: {
        SET_UNSEEN_COUNT(state, count) {
            const value = Number(count)
            state.unseenCount = Number.isFinite(value) && value > 0 ? value : 0
            state.loaded = true
        },
        DECREMENT_UNSEEN_COUNT(state, amount = 1) {
            state.unseenCount = Math.max(0, state.unseenCount - amount)
        },
    },
    actions: {
        fetchUnseenCount({commit, state, rootGetters}, options = {}) {
            const force = Boolean(options && options.force)
            if (!rootGetters['User/isAdmin']) {
                return Promise.resolve(0)
            }
            if (!force && countPromise) {
                return countPromise
            }
            const axios = getAxiosInstance()
            countPromise = axios.get('form-fills/unseen-count').then((res) => {
                const data = (res.data && res.data.data) || {}
                commit('SET_UNSEEN_COUNT', data.unseen_count)
                return state.unseenCount
            }).catch(() => {
                return state.unseenCount
            }).finally(() => {
                countPromise = null
            })
            return countPromise
        },
        setUnseenCount({commit}, count) {
            commit('SET_UNSEEN_COUNT', count)
        },
        fetchFormFills(context, {formId, page = 1, filter = 'all'}) {
            const axios = getAxiosInstance()
            const params = {page}
            if (filter === 'new') {
                params.filter = 'new'
            }
            return axios.get(`/form-fills/${formId}`, {params}).then((res) => {
                return (res.data && res.data.data) || {}
            })
        },
        markAllSeen({commit}, formId) {
            const axios = getAxiosInstance()
            return axios.post(`form-fills/${formId}/mark-all-seen`).then((res) => {
                const data = (res.data && res.data.data) || {}
                if (data.unseen_count !== undefined) {
                    commit('SET_UNSEEN_COUNT', data.unseen_count)
                }
                return data
            })
        },
    },
    getters: {
        unseenCount: (state) => state.unseenCount,
        loaded: (state) => state.loaded,
    },
}
